import React, { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import Container from "react-bootstrap/Container"
import "./NavBarFixedTop.css"

export function NavbarFixedTop() {
	const [expanded, setExpanded] = useState(false)
	const [scrolled, setScrolled] = useState(false)
	const [visible, setVisible] = useState(true)
	const location = useLocation()

	useEffect(() => {
		setExpanded(false)
		setVisible(true)
	}, [location.pathname])

	useEffect(() => {
		let lastScrollY = window.pageYOffset || document.documentElement.scrollTop

		const handleScroll = () => {
			const currentScrollY = window.pageYOffset || document.documentElement.scrollTop

			// Track scrolled background
			if (currentScrollY > 20) {
				setScrolled(true)
			} else {
				setScrolled(false)
			}

			// Don't hide if mobile menu is currently expanded
			if (expanded) return

			// Threshold: hide when scrolling down past 80px, show when scrolling up
			if (currentScrollY > lastScrollY && currentScrollY > 80) {
				setVisible(false)
			} else {
				setVisible(true)
			}

			lastScrollY = currentScrollY > 0 ? currentScrollY : 0
		}

		window.addEventListener("scroll", handleScroll, { passive: true })
		return () => window.removeEventListener("scroll", handleScroll)
	}, [expanded])

	const isActive = (path) => {
		if (path === "/" && location.pathname === "/") return true
		if (path !== "/" && location.pathname.startsWith(path)) return true
		return false
	}

	return (
		<Navbar
			id="indexNavbar"
			expanded={expanded}
			onToggle={(nextExpanded) => setExpanded(nextExpanded)}
			expand="lg"
			fixed="top"
			variant="dark"
			className={`clean-navbar ${scrolled ? "navbar-scrolled shadow" : "shadow-sm"} ${visible ? "navbar-visible" : "navbar-hidden"}`}
		>
			<Container fluid="lg">
				<Navbar.Brand as={Link} to="/" className="d-flex align-items-center text-decoration-none">
					<span className="brand-title fw-bold text-white fs-4">NCDIA</span>
				</Navbar.Brand>

				<Navbar.Toggle aria-controls="navbarContent" aria-label="Toggle navigation" />
				<Navbar.Collapse id="navbarContent" className="text-center">
					<Nav className="ms-auto my-2 my-lg-0 align-items-center">
						<Nav.Link as={Link} to="/" className={`nav-item-link px-3 ${isActive("/") ? "active" : ""}`}>
							Início
						</Nav.Link>
						<Nav.Link as={Link} to="/projects" className={`nav-item-link px-3 ${isActive("/projects") ? "active" : ""}`}>
							Projetos
						</Nav.Link>
						<Nav.Link as={Link} to="/publications" className={`nav-item-link px-3 ${isActive("/publications") ? "active" : ""}`}>
							Publicações
						</Nav.Link>
						<Nav.Link as={Link} to="/resources" className={`nav-item-link px-3 ${isActive("/resources") ? "active" : ""}`}>
							Recursos
						</Nav.Link>
						<Nav.Link as={Link} to="/about" className={`nav-item-link px-3 ${isActive("/about") ? "active" : ""}`}>
							Sobre nós
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	)
}
